var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPageCopy = function SvgPageCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#3ABCA8",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "page-copy_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#page-copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177v-10c0-.458.164-.85.49-1.177.326-.326.719-.49 1.177-.49H15c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177v10c0 .459-.164.851-.49 1.177-.326.327-.719.49-1.177.49H7.5Zm0-1.667H15v-10H7.5v10Zm-3.333 5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V5.833c0-.236.08-.434.24-.593.16-.16.357-.24.593-.24s.434.08.594.24c.16.16.24.357.24.593v10.834H12.5c.236 0 .434.08.594.24.16.159.24.357.24.593s-.08.434-.24.594a.806.806 0 0 1-.594.24H4.167Z"
  }))));
};

export default SvgPageCopy;